// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2sSIt","separator":"styles_separator__olvoK","item":"styles_item__lkVIi"};